import * as React from "react";
const SvgAttachement20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.01 3.49a5 5 0 0 0-7.07 0l-7.072 7.07L.454 9.147l7.071-7.07a7 7 0 1 1 9.9 9.899l-6.364 6.364a5 5 0 1 1-7.071-7.071l6.364-6.364a3 3 0 0 1 4.242 4.242l-7.07 7.072-1.415-1.415 7.071-7.07a1 1 0 0 0-1.414-1.415l-6.364 6.364a3 3 0 1 0 4.242 4.243l6.364-6.364a5 5 0 0 0 0-7.071Z",
      clipRule: "evenodd"
    })
  );
export default SvgAttachement20Px;
